import ModalConfirmTrigger from "./ModalConfirmTrigger";

export default ModalConfirmTrigger;
